

class SnapshotWidgetController {
    constructor($scope, LoadedModel) {
        this._$scope = $scope;
        this.model = LoadedModel;
        this.snapshots = this.model.snapshots;
    }

    takeSnapshot() {
        let type = this.model.getViewKey(this.type);

        if (!this.model[type] && type === 'nestView') {
            type =  'blankView';
        }

        this.model.takeSnapshot(type);
    }
}

SnapshotWidgetController.$inject = ['$scope', 'LoadedModel'];

export default SnapshotWidgetController;



// WEBPACK FOOTER //
// ./client/app/common/snapshot-widget/snatpshot-widget.controller.js